import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

export const SIGLIP_RECS_TEST_NAME = 'SiglipRecs_Aug2026';

export type UserRecommendationType = 'PERSONALIZED' | 'PERSONALIZED_SIGLIP';

export const USER_RECOMMENDATION_TYPE = {
    PERSONALIZED: 'PERSONALIZED',
    PERSONALIZED_SIGLIP: 'PERSONALIZED_SIGLIP',
} as const satisfies Record<string, UserRecommendationType>;

export const isSiglipRecsTestVariant = (): boolean =>
    getAbTestV2(SIGLIP_RECS_TEST_NAME)?.variant === 'variant';

export const getUserRecommendationType = (): UserRecommendationType =>
    isSiglipRecsTestVariant()
        ? USER_RECOMMENDATION_TYPE.PERSONALIZED_SIGLIP
        : USER_RECOMMENDATION_TYPE.PERSONALIZED;

export const trackSiglipRecsTest = (): void => {
    trackAbTestV2Variant(SIGLIP_RECS_TEST_NAME);
};
